import React, { useMemo } from 'react'
import { getNotifications } from '@/lib/supabase/notification'
import { supabaseClient } from '@/configs/supabase'
import { useSubscription } from '@/lib/supabase/hooks/useSubscription'
import { orderBy, filter } from 'lodash'
import { useUserAuthData } from '@/state/userAuth/hooks'

export const useNotifications = (count = 10) => {
  const userAuthData = useUserAuthData()

  const { rows } = useSubscription(
    'Notification',
    {
      k: 'user_id',
      v: userAuthData?.id ?? ''
    },
    () => getNotifications(supabaseClient, userAuthData?.id as string, count)
  )
  return useMemo(
    () => orderBy(filter(rows, ['deleted_at', null]), ['created_at'], ['desc']),
    [rows]
  )
}
